import * as stylex from "@stylexjs/stylex";
import "./tokens.stylex.ts";
import { color, shadow, texture } from "./tokens.stylex.ts";

/**
 * Dark theme — the same paper language at night: near-black surfaces, the
 * brand blue for primary actions and selection (lifted for text so it reads on
 * dark), and deeper shadows so raised faces still separate from the page.
 *
 * Apply every override together on a root element (the app does this on
 * `<html>`, so portaled popups inherit it too):
 *
 *   element.className = stylex.props(...darkTheme).className
 */
const darkColor = {
  xavfpcn: "x13uk3jg xavfpcn",
  $$css: true
};
const darkShadow = {
  xubp3va: "x1x6yb14 xubp3va",
  $$css: true
};
const darkTexture = {
  x1lpt968: "xtv8s7s x1lpt968",
  $$css: true
};
export const darkTheme = [darkColor, darkShadow, darkTexture] as const;